import moment from 'moment';
import React, { useEffect } from 'react';
import { View, Image } from "react-native"
import { Icon } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { player_getBulkPlayers } from '../../../store/actionsv1/player';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import { BracketCompetitionProps, CompetitionPlayerBracketProps } from "../../../store/types/tp_svc"

type BracketCompetitionCardProps = {
    bracket_competition: BracketCompetitionProps,
    entered_brackets?: CompetitionPlayerBracketProps[],
    onSelect: (bracket_competition:BracketCompetitionProps) => void
}
const BracketCompetitionCard = ({bracket_competition, entered_brackets, onSelect}:BracketCompetitionCardProps) => {
    
    const dispatch = useDispatch();
    const admin:PublicPlayerProps | undefined = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == bracket_competition.admin_id), (left, right) => left?.player_id == right?.player_id)
    const sponsor:PublicPlayerProps | undefined = useSelector((state:any) => state.social.stored_players.find(p => p.player_id == bracket_competition.sponsor_id), (left, right) => left?.player_id == right?.player_id)

    useEffect(() => {
        if(bracket_competition.sponsor_id && !sponsor){ dispatch(player_getBulkPlayers([bracket_competition.sponsor_id])) }
    },[])

    const cl = bracket_competition.market_type == 'FOR_MONEY'?'$':'E'

    return (
        <TouchableOpacity style={{flex:1, borderRadius:8, paddingBottom:15, backgroundColor:'rgba(26,205,106,0.1)', margin:6, borderWidth:1, borderColor:Colors.highlights.highlight400Faded }} onPress={() => onSelect(bracket_competition)}>
            <View style={{flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                <View style={{backgroundColor:Colors.highlights.highlight500, borderTopLeftRadius:8, padding:6, paddingLeft:10, borderWidth:1, borderColor:Colors.highlights.highlight500}}>
                    <Text size={10} color={Colors.shades.white} weight='bold'>BRACKET - PROGRESSIVE</Text>
                </View>
                {bracket_competition.invite_only?
                <View style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-end', marginLeft:10, paddingRight:10}}>
                    <Text size={14} color={Colors.shades.white} textAlign='right' weight='regular'>PRIVATE</Text>
                    <Icon containerStyle={{marginLeft:4}} name='eye-off' type='feather' size={10} color={Colors.accents.accent100} />
                </View>
                :
                <View style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-end', marginLeft:10, paddingRight:10}}>
                    <Text size={14} color={Colors.shades.white} textAlign='right' weight='regular'>PUBLIC</Text>
                    <Icon containerStyle={{marginLeft:4}} name='users' type='feather' size={10} color={Colors.accents.accent100} />
                </View>
                }
            </View>
            <View style={{padding:12}}>
                {!bracket_competition.sponsor_id?
                <View style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-start'}}>
                    <Image style={{height:24, width:24, borderRadius:100}} source={admin?.profile_pic?{ uri: admin.profile_pic }:require('../../../assets/images/default-avatar.png')} />
                    <Text size={12} color={Colors.brand.midnight} style={{ marginLeft:6 }}>{admin?.first_name} {admin?.last_name}</Text>
                </View>
                :
                <View style={{flexDirection:'row', alignItems:'center', justifyContent:'flex-start'}}>
                    <Image style={{height:24, width:24, borderRadius:100}} source={sponsor?.profile_pic?{ uri: sponsor?.profile_pic }:require('../../../assets/images/default-avatar.png')} />
                    <Text size={12} color={Colors.brand.midnight} style={{ marginLeft:6 }}>{sponsor?.first_name} {sponsor?.last_name}</Text>
                </View>
                }
                {bracket_competition.promo_payout?
                    <Text size={12} color={Colors.brand.midnight} weight='bold' style={{ marginTop:4 }}>${bracket_competition.promo_payout.toFixed(2)} Added To Payout</Text>
                :<></>}
                <Text size={12} color={Colors.highlights.highlight200} style={{ marginTop:4 }}>{moment(bracket_competition.scheduled_datetime).format('MMM DD - hh:mm a')}</Text>
                <View style={{width:40, height:1, borderBottomWidth:1, borderBottomColor:Colors.accents.accent200, justifyContent:'center', alignSelf:'flex-start', marginTop:8, marginBottom:4}} />
                <Text size={12} color={Colors.brand.electric} weight='semibold' style={{ marginTop:4 }}>{bracket_competition.competition_name}</Text>
                {bracket_competition.competition_description ?
                <Text size={12} color={Colors.brand.electric} weight='regular' style={{ marginTop:4 }}>{bracket_competition.competition_description.substring(0,30)}...</Text>
                :<></>}
                <Text size={12} color={Colors.brand.midnight} style={{ marginTop:4 }}>Ticket Price: {cl}{bracket_competition.buy_in}</Text>
                <Text size={12} color={Colors.brand.midnight} style={{ marginTop:4 }}>Max Brackets: {bracket_competition.max_brackets}</Text>
                <Text size={12} color={Colors.brand.midnight} style={{ marginTop:4 }}>Brackets / Player: {bracket_competition.max_brackets_per_player}</Text>
                {bracket_competition.market_type === 'FREE' ?
                <Text size={12} color={Colors.brand.midnight} weight='semibold' style={{ marginTop:4, flex:1 }}>FREE ENTRY!</Text>
                :<></>}
            </View>
            {entered_brackets && entered_brackets.length > 0 ?
            <View style={{ position:'absolute', bottom:5, right:5, backgroundColor:Colors.brand.midnight, borderRadius:20, padding:5 }}>
                <Text style={{ paddingRight:5, paddingLeft:5 }} size={10} weight='regular' color={Colors.shades.white}>{entered_brackets.length} bracket(s)</Text>
            </View>
            :<></>}
        </TouchableOpacity>
    )
}

export default BracketCompetitionCard